module.exports = ".tamanho-input-btn {\n    width: 6.3333% !important;\n    margin-top: 26px !important;\n}\n\n.tamanho-input {\n    width: 170px !important;\n}\n\n.posicao-botao {\n    margin-top: 45px !important;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cadastro-dependencia/cadastro-dependencia.component.css
// module id = ./src/app/cadastro-dependencia/cadastro-dependencia.component.css
// module chunks = main